import { TimeSyncService } from '@services/TimeSyncService';
import { isToday } from 'date-fns/isToday';
import { isTomorrow } from 'date-fns/isTomorrow';

import { useCountdownUntill } from '@libs/hooks/useCountdownUntill';
import { DateView, TimeView, YearView } from '@ui/components/DateView';
import { Timer } from '@ui/components/Timer';

import { Tournament } from '@features/shared/api/typings';
import { Props } from '@features/tournament/ui/components/TournamentStatusView/TournamentStatusView';

import styles from './TournamentStartDate.module.css';

export function TournamentStartDate({ tournament }: { tournament: Tournament }) {
  const date = new Date(tournament.startTimestampMs || 0);
  const isCloseDate = isToday(date) || isTomorrow(date);

  const time = useTournamentCountdown(tournament);

  return (
    <div className={styles.tournamentStartDate}>
      <div className={styles.dateContainer}>
        <DateView className={styles.date} date={date} year="hide" />
        {!isCloseDate && <YearView className={styles.year} date={date} />}
      </div>
      <div className={styles.timeContainer}>
        {isToday(date) ? (
          <Timer showHours seconds={time} />
        ) : (
          <TimeView className={styles.time} date={date} />
        )}
        <div className={styles.timeZone}>по&nbsp;Москве</div>
      </div>
    </div>
  );
}

function useTournamentCountdown(t: Props['tournament']) {
  const stop = t?.status !== 'Draft' && t?.status !== 'NotStarted';
  const timestamp = TimeSyncService.instance.toClientTimestamp(t?.startTimestampMs) ?? 0;
  const { seconds: time } = useCountdownUntill(timestamp, stop);
  return time;
}
